/**
 * Active case study's text color. `null` = default site behavior
 * (Nav/Footer white + mix-blend-difference). Portfolio sets this to the
 * open case study's `textColor` so the global Nav/Footer transition to a
 * per-project color while the panel is open, then back to `null` on close.
 * (The case-study panel itself reads the slide's `textColor` directly.)
 *
 * Module-level atom on Jotai's default store (the app has no <Provider>),
 * so Portfolio (inside <Routes>) and Nav/Footer (outside it) share it.
 */
import { atom } from "jotai";

export const textColorAtom = atom<string | null>(null);
